import { observer } from "mobx-react";
import React from "react";
import styled, { css } from "styled-components";

import Style from "@client/utils/Style";

import checkmarkImage from "./images/checkmark.svg";

const CheckmarkImage = styled.div`
  width: 10px;
  height: 7px;
  background: url("${checkmarkImage}") no-repeat center;
  transform: scale(0);
  transition: transform 250ms cubic-bezier(0, 1.4, 1, 1);
`;
const Wrapper = styled.div<{ checked?: boolean; disabled?: boolean }>`
  display: flex;
  ${props => (props.disabled ? "" : "cursor: pointer;")}
  ${props => (props.disabled ? "opacity: 0.9;" : "")}
  justify-content: center;
  align-items: center;
  ${Style.exactSize("16px")}
  border: 1px solid ${Style.palette.grayscale[3]};
  border-radius: 3px;
  background: white;
  transition: all ${Style.animations.swift};
  ${props =>
    props.checked
      ? css`
          border-color: ${Style.palette.primaryHighlight};
          background: ${Style.palette.primaryHighlight};
          ${CheckmarkImage} {
            transform: scale(1);
          }
        `
      : ""}
`;

type Props = {
  className?: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
};
@observer
class Checkbox extends React.Component<Props> {
  handleClick() {
    if (this.props.disabled || !this.props.onChange) {
      return;
    }

    this.props.onChange(!this.props.checked);
  }

  render() {
    return (
      <Wrapper
        className={this.props.className}
        onClick={() => {
          this.handleClick();
        }}
        checked={this.props.checked}
        disabled={this.props.disabled}
      >
        <CheckmarkImage />
      </Wrapper>
    );
  }
}

export default Checkbox;
